/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/components';

/**
 * Block user interface icons
 */
const icons = {};

icons.imageLeft = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
		<Path d="m11 15v-10h-10v10zm2-6h6v-2h-6zm0 4h6v-2h-6z" />
	</SVG>
);
icons.imageRight = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
		<Path d="m19 15v-10h-10v10zm-18-6h6v-2h-6zm0 4h6v-2h-6z" />
	</SVG>
);
icons.styleHorizontalImageRight = (
	<SVG
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 56 26"
		height="26"
		width="56"
	>
		<Path d="m48 11.0910645v-10.00000005h-10v10.00000005zm-40-6.00000005h24v-2h-24zm0 4v-2h18v2zm40 16.00000005h-10v-10h10zm-40-6v-2h24v2zm0 4v-2h18v2z" />
	</SVG>
);
icons.styleHorizontalImageLeft = (
	<SVG
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 56 26"
		height="26"
		width="56"
	>
		<Path d="m18 11.0910645v-10.00000005h-10v10.00000005zm6-6.00000005h24v-2h-24zm0 4v-2h18v2zm-6 16.00000005h-10v-10h10zm6-6v-2h24v2zm0 4v-2h18v2z" />
	</SVG>
);
icons.styleStacked = (
	<SVG
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 56 26"
		height="26"
		width="56"
	>
		<Path d="m26 17v-16h-16v16zm-16 4h10v-2h-10zm0 4v-2h10v2zm36-8h-16v-16h16zm-16 4v-2h10v2zm0 4v-2h10v2z" />
	</SVG>
);

export default icons;
